import { render, staticRenderFns } from "./TaskActive.vue?vue&type=template&id=c7b6ad3c&scoped=true"
import script from "./TaskActive.vue?vue&type=script&lang=js"
export * from "./TaskActive.vue?vue&type=script&lang=js"
import style0 from "./TaskActive.vue?vue&type=style&index=0&id=c7b6ad3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b6ad3c",
  null
  
)

export default component.exports